import React from 'react';
import ContentModuleForm from '../../../../components/forms/ContentModuleForm';

export default function ContentsModulesCreatePage() {
  return <ContentModuleForm />;
}
